<div class="modal" (click)="onOutModalClick($event)">
  <div class="modal-content">
    <ng-content></ng-content>
  </div>
</div>
